import {sleep} from '@benchling/js-utils';

import * as Net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

const POLL_TIMEOUT_MS = 1000;

export interface SendDeepResearchMessageResponse {
  response: string;
}

export async function sendDeepResearchMessage(
  chatId: string | undefined,
  message: string,
  updateProgress: () => void
): Promise<SendDeepResearchMessageResponse> {
  const initialResponse = await Net.postJSONPromise({
    url: '/1/api/llm/deep-research',
    data: {chatId, message},
  });

  const statusURL = initialResponse.status_url;
  let taskStatus = await Net.getJSONPromise(statusURL);

  while (taskStatus.status !== 'SUCCESS' && taskStatus.status !== 'FAILURE') {
    await sleep(POLL_TIMEOUT_MS);
    taskStatus = await Net.getJSONPromise(statusURL);
    if (taskStatus.partialResult) {
      updateProgress();
    }
  }

  if (taskStatus.status === 'FAILURE') {
    throw TaskRunner.flagTaskError(TaskRunner.getFailedTaskErrorResponse(taskStatus));
  }

  return taskStatus.result;
}
